<template>
  <div>
      <div class="custom-filter without-border-bottom">
          <div class="custom-filter__inputs align-start">
  <!--            Categories-->
              <label class="custom-filter__inputs--label" style="max-width: 160px">
                Garantie
                <div class="checkboxes-wrap--item" v-if="!isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.vp_vu_4x4.value"/>
                    <span class="checkboxes__element--text"> VP - VU - 4x4</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="!isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.camping_car.value"/>
                    <span class="checkboxes__element--text"> Camping-Car</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="!isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.moto.value"/>
                    <span class="checkboxes__element--text"> Moto</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.tondeuse.value"/>
                    <span class="checkboxes__element--text"> Tondeuse, Robot</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.tronconneuse.value"/>
                    <span class="checkboxes__element--text"> Tronçonneuse</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.taillehaie.value"/>
                    <span class="checkboxes__element--text"> Taille-Haie</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.debrousailleuse.value"/>
                    <span class="checkboxes__element--text"> Débrousailleuse</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.elagueuse.value"/>
                    <span class="checkboxes__element--text"> Elagueuse</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item" v-if="isGarden">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.categories.autres.value"/>
                    <span class="checkboxes__element--text"> Autres</span>
                  </label>
                </div>
              </label>
  <!--            Garantie Types-->
              <label class="custom-filter__inputs--label" v-if="!isGarden">
              Type de guarantie
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_types.standard.value"/>
                  <span class="checkboxes__element--text">Standard</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_types.reseau.value"/>
                  <span class="checkboxes__element--text">Réseau</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_types.maxi_reseau.value"/>
                  <span class="checkboxes__element--text">Maxi-Réseau</span>
                </label>
              </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.garantie_types.maxi_plus.value"/>
                    <span class="checkboxes__element--text">Maxi Plus</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.garantie_types.prestige.value"/>
                    <span class="checkboxes__element--text">Prestige</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.garantie_types.complete.value"/>
                    <span class="checkboxes__element--text">Complète</span>
                  </label>
                </div>
            </label>
  <!--            Durations-->
              <label class="custom-filter__inputs--label">
                Durée
              <div class="checkboxes-wrap--item" v-if="!isGarden">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_durations.mois_3.value"/>
                  <span class="checkboxes__element--text">3 Mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item" v-if="!isGarden">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_durations.mois_6.value"/>
                  <span class="checkboxes__element--text">6 Mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_durations.mois_12.value"/>
                  <span class="checkboxes__element--text">12 Mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_durations.mois_24.value"/>
                  <span class="checkboxes__element--text">24 Mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item" v-if="!isGarden">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_durations.mois_36.value"/>
                  <span class="checkboxes__element--text">36 Mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item" v-if="!isGarden">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_durations.mois_48.value"/>
                  <span class="checkboxes__element--text">48 Mois</span>
                </label>
              </div>
            </label>
              <div class="custom-filter__inputs--label">
                  Date

                  <div class="label currency-datepicker">
                      <div class="label__input-wrap">
                          <datepicker placeholder="De"
                                      format="DD/MM/YYYY"
                                      :monday-first="true"
                                      :full-month-name="true"
                                      wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                                      input-class="currency-datepicker__input"
                                      calendar-class="currency-datepicker__element"
                                      v-model="filters.start_date"
                                      @focusout.native="focusOutStartDate"
                                      :highlighted="filters.start_date ? '' : highlightedConfig"
                          >
                          </datepicker>
                          <datepicker placeholder="à"
                                      format="DD/MM/YYYY"
                                      :monday-first="true"
                                      :full-month-name="true"
                                      wrapper-class="currency-datepicker__wrapper-low-margin"
                                      input-class="currency-datepicker__input"
                                      calendar-class="currency-datepicker__element"
                                      v-model="filters.end_date"
                                      @focusout.native="focusOutEndDate"
                                      :highlighted="filters.end_date ? '' : highlightedConfig"
                          >
                          </datepicker>
                      </div>
                  </div>
              </div>
  <!--            Periods-->
              <label class="custom-filter__inputs--label">
                Plage de dates
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.today.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Aujourd’hui</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.yesterday.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Hier</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.this_week.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Cette semaine </span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.last_week.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">La semaine dernière</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.this_month.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Ce mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.last_month.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Le mois dernier</span>
                </label>
              </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.periods.this_year.value" :disabled="!isDatesAreEmpty"/>
                    <span class="checkboxes__element--text">Cette année</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.periods.last_year.value" :disabled="!isDatesAreEmpty"/>
                    <span class="checkboxes__element--text">L’année dernière</span>
                  </label>
                </div>
            </label>
            <label class="custom-filter__inputs--label" v-if="isGarden">
              Montant minimum
              <input class="custom-filter__inputs--field text-type" v-model="filters.min_amount">
            </label>
            <label class="custom-filter__inputs--label" v-if="isGarden">
              <div class="custom-filter__buttons stats" style="align-items: center; display: flex;">
                <div style="flex-basis: 90%;"><button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button></div>
                <div><button class="custom-filter custom-icon icon-csv" @click="downloadCSV"></button></div>
                <div><button class="custom-filter custom-icon icon-xlsx" @click="downloadXLSX"></button></div>
              </div>
            </label>
          </div>
      </div>
      <div class="custom-filter__inputs align-start with-border-bottom" v-if="!isGarden">
        <label class="custom-filter__inputs--label">
          Montant minimum
          <input class="custom-filter__inputs--field text-type" v-model="filters.min_amount">
        </label>
        <label class="custom-filter__inputs--label">
          Immatriculation
          <input class="custom-filter__inputs--field text-type" v-model="filters.registration">
        </label>
        <label class="custom-filter__inputs--label" v-if="representative_id">
          Partenaire
          <input class="custom-filter__inputs--field text-type" v-model="filters.mechanic_garage">
        </label>
      </div>
      <div class="custom-filter__buttons stats" style="align-items: center; display: flex;" v-if="!isGarden">
        <div style="flex-basis: 90%;"><button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button></div>
        <div><button class="custom-filter custom-icon icon-csv" @click="downloadCSV"></button></div>
        <div><button class="custom-filter custom-icon icon-xlsx" @click="downloadXLSX"></button></div>
      </div>
  </div>
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'

    export default {
        name: 'StatisticsCustomFilter',
        components: {Datepicker},
        data() {
            return {
              highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
        props: {
            filters: Object
        },
        computed: {
          isDatesAreEmpty() {
            return !this.filters.start_date && !this.filters.end_date;
          },
          mechanic_id() {
            return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
          },
          representative_id() {
            return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
          },
          isGarden() {
            return this.$store.getters.isGarden;
          },
        },
        methods: {
            emitFilters() {
                this.$emit('getGarantiesWithFilters');
            },
            focusOutStartDate(event) {
              if (event.target.value == "") {
                this.filters.start_date = null;
                if (!this.filters.end_date) {
                    if (this.filters.periods) {
                      for (let i in this.filters.periods) {
                        let periods = this.filters.periods[i];
                        periods.value = false;
                      }
                    }
                }
              }
            },
            focusOutEndDate(event) {
              if (event.target.value == "") {
                this.filters.end_date = null;
                if (!this.filters.start_date) {
                  if (this.filters.periods) {
                    for (let i in this.filters.periods) {
                      let periods = this.filters.periods[i];
                      periods.value = false;
                    }
                  }
                }
              }
            },
            downloadCSV () {
              this.$emit('garantiesDownloadCSV');
            },
            downloadXLSX () {
              this.$emit('garantiesDownloadXLSX');
            },
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Statistics/StatisticsCustomFilter.vue